import { z } from 'zod';

/** Dados estruturados da regra para a UI traduzir na borda (D3). Opcional:
 *  produtor antigo não manda; consumidor antigo (strict) só aceita depois de
 *  deployado — ordem de deploy documentada no PR. */
export const ModalSessionFlightPolicyRuleParamsSchema = z
  .object({
    days: z.number().int().nonnegative(),
    scope: z.enum(['domestic', 'international']),
  })
  .strict();

/** Uma regra da gaveta de política da oferta: o veredito dela e, nas de
 *  antecedência, a janela exigida. */
export const ModalSessionFlightPolicyRuleSchema = z
  .object({
    key: z.string().min(1),
    title: z.string().min(1),
    status: z.enum(['ok', 'violated', 'na']),
    text: z.string().optional(),
    params: ModalSessionFlightPolicyRuleParamsSchema.optional(),
  })
  .strict();
export type ModalSessionFlightPolicyRule = z.infer<typeof ModalSessionFlightPolicyRuleSchema>;

/** UMA regra que reprovou a tarifa (#5262) — o motivo da justificativa
 *  obrigatória no checkout e, na escada de tarifas, do selo de cada família
 *  (#5797). `key` é a chave pública da regra (o mesmo vocabulário de
 *  `ModalSessionFlightPolicyRule.key`); `params` só nas de antecedência, com a
 *  janela exigida e o escopo dela, para a UI dizer "antecedência mínima de N dias
 *  para viagens nacionais". `key: 'withinPolicy'` = a tarifa reprovou sem dizer
 *  por qual regra (ex.: política dinâmica). */
export const ModalSessionFlightPolicyViolationSchema = z
  .object({
    key: z.string().min(1),
    params: ModalSessionFlightPolicyRuleParamsSchema.optional(),
  })
  .strict();
export type ModalSessionFlightPolicyViolation = z.infer<
  typeof ModalSessionFlightPolicyViolationSchema
>;

/** Os motivos como o HOST os lê (schema tolerante da vista de tarifas, #5797): item a
 *  item, um motivo malformado cai sozinho, sem levar os válidos junto; nenhum válido
 *  é o mesmo que nenhum motivo. */
export const ModalSessionFlightPolicyViolationsWireSchema = z
  .array(z.unknown())
  .transform((items) =>
    items.flatMap((item) => {
      const parsed = ModalSessionFlightPolicyViolationSchema.safeParse(item);
      return parsed.success ? [parsed.data] : [];
    }),
  )
  .transform((items) => (items.length > 0 ? items : undefined))
  .optional()
  .catch(undefined);
